import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import MotPage from "@/pages/MotPage";
import ServicingPage from "@/pages/ServicingPage";
import WetBeltsPage from "@/pages/WetBeltsPage";
import InspectionPage from "@/pages/InspectionPage";
import CarsPage from "@/pages/CarsPage";
import CarPage from "@/pages/CarPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import BookingPage from "@/pages/BookingPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Cars from "@/pages/admin/Cars";
import CarForm from "@/pages/admin/CarForm";
import Bookings from "@/pages/admin/Bookings";
import Enquiries from "@/pages/admin/Enquiries";
import Settings from "@/pages/admin/Settings";

function AdminGate() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-navy flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-sky border-t-transparent rounded-full animate-spin" data-testid="admin-loading" />
      </div>
    );
  }
  if (!user) return <AdminLogin />;
  return <AdminLayout />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/mot-testing-adlington" element={<MotPage />} />
              <Route path="/car-servicing-adlington" element={<ServicingPage />} />
              <Route path="/ford-wet-belt-replacement" element={<WetBeltsPage />} />
              <Route path="/vehicle-inspection" element={<InspectionPage />} />
              <Route path="/cars-for-sale" element={<CarsPage />} />
              <Route path="/cars-for-sale/:id" element={<CarPage />} />
              <Route path="/about-us" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/booking" element={<BookingPage />} />
            </Route>
            <Route path="/admin" element={<AdminGate />}>
              <Route index element={<Dashboard />} />
              <Route path="cars" element={<Cars />} />
              <Route path="cars/new" element={<CarForm />} />
              <Route path="cars/:id/edit" element={<CarForm />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="enquiries" element={<Enquiries />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
